import React from "react";

const BetterLoading = () => {
  return (
    <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-white bg-opacity-80">
      <div className="flex flex-col items-center">
        <svg
          className="animate-spin h-16 w-16 text-[#3E3232]"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          ></circle>
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
          ></path>
        </svg>
        <h1 className="mt-4 text-[#3E3232] font-semibold text-xl">Loading...</h1>
      </div>
    </div>
  );
};

export default BetterLoading;
